import { render, staticRenderFns } from "./CommissionSuggestionPanel.vue?vue&type=template&id=4819f298&scoped=true&"
import script from "./CommissionSuggestionPanel.vue?vue&type=script&lang=js&"
export * from "./CommissionSuggestionPanel.vue?vue&type=script&lang=js&"
import style0 from "./CommissionSuggestionPanel.vue?vue&type=style&index=0&id=4819f298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4819f298",
  null
  
)

export default component.exports